import React from "react";
import "./style/index.scss";
import { SafeAreaView } from "react-native";
import { DeployTypes, ServiceWrapper } from "./services/ServiceWrapper";
import { MainContainer } from "./components/containers/MainContainer";
import { ApplicationProvider } from "./contexts/ApplicationContext";
import { EventProvider } from "./contexts/EventContext";

export type AppProps = {
    deployType?: DeployTypes;
    tenantSlug: string;
    alternateTheme?: boolean;
    eventId?: string;
};

export const App = ({ deployType, tenantSlug, alternateTheme, eventId }: AppProps): JSX.Element => {
    return (
        <ServiceWrapper deployType={deployType} tenantSlug={tenantSlug} alternateTheme={alternateTheme}>
            <ApplicationProvider eventId={eventId}>
                <EventProvider>
                    <SafeAreaView>
                        <MainContainer />
                    </SafeAreaView>
                </EventProvider>
            </ApplicationProvider>
        </ServiceWrapper>
    );
};
